import { DrawerItem } from "./drawer-item";
import { DrawerProps } from "./types";
import { Footer } from "./footer";
import { Header } from "./header";
import { ToggleButton } from "./toggle-button";
import React, { useState } from "react";

export const Drawer = (props: DrawerProps): React.ReactElement => {
  const { routes, isPageActive, goTo, logout, username, avatar } = props;
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <section
      className={`shadow-c-sm box-border flex h-screen flex-col rounded-r-xl bg-black px-[16px] pt-[1.5rem] pb-[1.5rem] text-gray-300 transition-all duration-700 ${
        isOpen ? "w-[200px]" : "w-[75px]"
      }`}
    >
      <ToggleButton isOpen={isOpen} toggle={() => setIsOpen(!isOpen)} />
      <Header isOpen={isOpen} avatar={avatar} username={username} />
      <section className="my-5 flex h-[100%] w-full flex-1 flex-col justify-start gap-[20px]">
        {routes.map((route, key) => (
          <DrawerItem
            key={key}
            {...route}
            isActive={isPageActive(key)}
            isOpen={isOpen}
            goTo={goTo}
          />
        ))}
      </section>
      <Footer isOpen={isOpen} logout={logout} />
    </section>
  );
};
